module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn_case_prev-36960a4f2999a8122e9913e3694d4a6e.svg";